import React from 'react';
import { useTranslation } from 'react-i18next';
import { RelanceListPage } from '../../features/relance/RelanceListPage';
import { useRelanceAgendaEntries } from '../../hooks/useRelanceAgendaEntries';
import { TranslationKey } from '../../i18n/translationKeys';

const TEST_IDS = {
    title: 'upcoming-relances-title',
    noAccess: 'upcoming-relances-no-access',
    error: 'upcoming-relances-error',
    empty: 'upcoming-relances-empty',
    list: 'upcoming-relances-agenda',
};

export const UpcomingRelances: React.FC = () => {
    const { t } = useTranslation();
    const { upcoming } = useRelanceAgendaEntries();

    return (
        <RelanceListPage
            title={t(TranslationKey.UpcomingRelances.Title)}
            emptyText={t(TranslationKey.UpcomingRelances.Empty)}
            entries={upcoming}
            showDates
            testIds={TEST_IDS}
        />
    );
};
